<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="admin-content">
      <div class="page-card-title">
        <span class="page-card-title-text">{{ $t('text.user_accounts') }}</span>
      </div>
      <div class="page-card-content">
        <div class="mt-20 page-content">
          <div class="section-title mb-20">
            <span class="right-float">
              <svg-icon
                iconClass="filter"
                className="content-element-color-more-lighter"
              ></svg-icon>
              <el-input
                v-model="filter"
                size="mini"
                class="search-input filter-input"
                :placeholder="$t('text.filter_by_user_name')"
              ></el-input>
            </span>
          </div>
          <el-table border :data="users" v-loading="loading">
            <el-table-column
              :label="$t('text.display_name')"
              prop="DisplayName"
            >
            </el-table-column>
            <el-table-column :label="$t('text.email')" prop="Email">
            </el-table-column>
            <el-table-column :label="$t('text.role')">
              <template slot-scope="scope">
                <div v-if="scope.row.UserRoles.length" class="inline-block">
                  <span v-for="(userRole, i) in scope.row.UserRoles" :key="i">
                    <span v-if="i !== 0">|</span>
                    {{ userRole.RoleName }}
                  </span>
                </div>
                <div v-else class="inline-block">--</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.action')"
              v-if="
                p('Manage Module.Users.User Accounts.Edit') ||
                  p('Manage Module.Users.User Accounts.Delete')
              "
            >
              <template slot-scope="scope">
                <div
                  class="blue-font underline pointer inline-block mr-10"
                  @click="editUser(scope.row)"
                  v-if="p('Manage Module.Users.User Accounts.Edit')"
                >
                  {{ $t('text.assign_roles') }}
                </div>
                <div
                  class="red-font underline pointer inline-block"
                  @click="deleteUser(scope.row)"
                  v-if="p('Manage Module.Users.User Accounts.Delete')"
                  v-show="scope.row.Email !== user.email"
                >
                  {{ $t('text.remove') | firstLetterCapitalize }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <EditUserAccount ref="editUser" />
    </div>
  </div>
</template>

<script>
import EditUserAccount from '@/components/manage/user/EditUserAccount.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      filter: '',
      users: [],
      loading: false,
      timer: '',
      user: JSON.parse(localStorage.getItem('user'))
    }
  },
  components: {
    EditUserAccount
  },
  mounted() {
    this.getData()
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getData() {
      this.users = []
      this.loading = true
      ApiService.GetAllUserAccount(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.users = response.data.data
            if (this.filter) {
              this.users = this.users.filter(item => {
                return (
                  item.DisplayName.toLowerCase().indexOf(
                    this.filter.toLowerCase()
                  ) > -1
                )
              })
            }
          }
        })
        .catch(() => {})
    },
    deleteUser(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_account_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') + ' ' + item.DisplayName,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeleteUser(item)
        })
        .catch(() => {})
    },
    handleDeleteUser(item) {
      this.loading = true
      ApiService.DeleteUserFromOrganisation(
        item.UserId,
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.loading = false
        if (response.data.success) {
          this.getData()
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    editUser(item) {
      this.$refs.editUser.openDialog()
      let obj = {
        RoleIds: item.UserRoles.map(item => {
          return item.Id
        }),
        EmailAddress: item.Email,
        DisplayName: item.DisplayName,
        Password: item.Password,
        UserId: item.UserId
      }
      this.$refs.editUser.form = JSON.parse(JSON.stringify(obj))
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
